import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Subscription from "./Subscription";
import { getAllPlan } from "../services/plans";
import BreadCrumb from "./Cards/BreadCrumbs";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import Loader from "../utils/loader";
import authService from "../services/authService";
import subscription from "../services/subscription";
import { 
  Box, 
  Typography, 
  Button, 
  Container,
  Paper
} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import AddCircleIcon from '@mui/icons-material/AddCircle';

function PricingPlan({ hide, currentUser }) {
  const [planList, setplanList] = useState([]);
  const [dashLink] = ["/admindashboard"];
  const [dashboardLink] = ["/subAdminDashboard"];
  const [loader, setLoader] = useState(false);
  const user = localStorage.getItem("Role") || "Individual";
  
  useEffect(() => {
    getSubscriptions();
  }, [user]);

  const getSubscriptions = async () => {
    try {
      const response = await subscription.getSubscriptions();
      if (response.status === 200) {
        const allSubscriptions = response?.data;
        const organizationPlans = allSubscriptions.filter(
          (plan) => plan.userType === user
        );
        const plans = organizationPlans;

        if (plans.length >= 3) {
          const temp = plans[1];
          plans[1] = plans[2];
          plans[2] = temp;
        }

        let html = plans.map((plan) => {
          const content = unOrderList(plan.billingCycle);
          const planName = plan?.name;
          const nameOfTerms = plan?.billingCycle;
          const planMode = { mode: plan?.planMode };
          const termDetails = convertToObj(plan?.billingCycle);
          const plan_id = plan?._id;
          const defaultPlan = plan?.isDefault;
          return {
            heading: planName,
            ul: content,
            btn_list: nameOfTerms,
            price_detail: termDetails,
            plan_mode: planMode,
            plan_id: plan_id,
            defaultPlan: defaultPlan
          };
        });
        setplanList(html);
        setLoader(false);
      }
    } catch (error) {
      console.log(error, "Error while fetching subscriptions");
    }
  };

  const convertToObj = (termDetails) => {
    const termObj = termDetails.reduce((newObj, obj) => {
      const { duration: term, price, totalUsers, userCounts } = obj;

      if (!term) {
        console.warn("Encountered an item with an undefined term:", obj);
        return newObj;
      }

      if (!newObj[term]) {
        newObj[term] = [];
      }

      newObj[term].push({ price, totalUsers, userCounts });

      return newObj;
    }, {});

    return termObj;
  };

  const unOrderList = (contentObj) => {
    if (contentObj) {
      const ul = contentObj.map((cycle, index) => {
        const { duration, price, totalUsers, userCounts } = cycle;
        const subscriptionText = `${duration.charAt(0).toUpperCase() + duration.slice(1)} subscription: $${price}/${duration}${user === "Organization" ? `, Total Users: ${totalUsers}` : ''}`;
        const userCountText = `Users: Admin - ${userCounts?.admin}, Power Users - ${userCounts?.powerUser}, Regular Users - ${userCounts?.regularUser}`;
        
        return (
          <li key={index}>
            <div>{subscriptionText}</div>
            {user === "Organization" && <div>{userCountText}</div>}
          </li>
        );
      });
      
      return (
        <ul>
          <lh>Subscription Details</lh>
          {ul}
        </ul>
      );
    }

    return null;
  };

  return (
    <Box sx={{ 
      minHeight: '100vh',
      background: 'white',
      py: 6
    }}> 
      <Loader loading={loader} />
      
      <Container maxWidth="xl">
        {!hide && (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            mb: 4
          }}>
            <Box />
            {currentUser && currentUser.isAdmin && (
              <Button
                component={Link}
                to="/addsubscription"
                variant="contained"
                startIcon={<AddCircleIcon />}
                sx={{
                  borderRadius: 3,
                  textTransform: 'none',
                  px: 3,
                  py: 1.5,
                  fontWeight: 600
                }}
              >
                Manage Plans
              </Button>
            )}
          </Box>
        )}

        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography 
            variant="h4" 
            sx={{ 
              color: '#003366',
              fontWeight: 600,
              mb: 2,
              // 3472af
              textShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            Explore for free and unlock additional features later on.
          </Typography>
          
          <Typography 
            variant="h3" 
            sx={{ 
              color: '#003366',
              fontWeight: 700,
              textShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            {currentUser && currentUser.isAdmin ? "Plans" : "Select your plan"}
          </Typography>
        </Box>

        <Grid 
          container 
          spacing={4}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'stretch'
          }}
        >
          {planList.map((obj, index) => (
            <Grid 
              size={{ xs: 12, sm: 6, md: 4 }} 
              key={index}
              sx={{
                display: 'flex',
                maxWidth: '400px', // Maximum width for each card
                width: '100%'
              }}
            >
              <Subscription
                price_detail={obj.price_detail}
                plan_id={obj.plan_id}
                planName={obj.heading}
                planList={obj.ul}
                btn_list={obj.btn_list}
                plan_mode={obj.plan_mode}
                hide={hide}
                defaultPlan={obj?.defaultPlan}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PricingPlan));